<template>
  <g-master name="job_assets"
            :endpoint="shiftMaster.endpoint"
            :tableSetup="shiftMaster.tableSetup"
            :parentData="jbParentData"
            :beforeSend="shiftMaster.beforeSend"
            :modalFieldsSetup="shiftMaster.modalFieldsSetup"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <g-dropdown endpoint="shifts_setup"
                    label="Turno"
                    :formItemConfig="fiOptions"
                    :decorator="['id_shifts_setup', { rules: [{ required: true, message: 'Valor requerido' }] }]"
        >
        </g-dropdown>
        <g-dropdown endpoint="hierarchy_lookup"
                    label="Día"
                    :formItemConfig="fiOptions"
                    :decorator="['id_h_days', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    :params="id_h_days_param">
        </g-dropdown>
        <a-col>
          <a-form-item v-bind="fiOptions" label="Descanso" :has-feedback="false">
            <a-checkbox v-decorator="['break', {valuePropName: 'checked'}]">
            </a-checkbox>
          </a-form-item>

        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    data () {
      return {
        id_h_days_param: {
          h_lookup_type: 'DIA_TURNO'
        },
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'shift_master',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Turno', dataIndex: 'id_shift', sorter: true},
              {title: 'Día', dataIndex: 'h_days', sorter: true},
              {title: 'H. inicial', dataIndex: 'start_time', sorter: true},
              {title: 'H. final', dataIndex: 'end_time', sorter: true},
              {title: 'H. diurnas', dataIndex: 'daily_hours', sorter: true},
              {title: 'H. nocturnas', dataIndex: 'night_hours', sorter: true},
              {title: 'H. extra diurnas', dataIndex: 'extra_daily_hours', sorter: true},
              {title: 'H. extra nocturnas', dataIndex: 'extra_night_hours', sorter: true},
              {title: 'Descanso', dataIndex: 'break_desc', sorter: true}
            ]
          },
          beforeSend: (data) => {
            data.id_shifts_type = this.id_type
            return data
          },
          modalFieldsSetup: [
            {name: 'id_shifts_setup'},
            {name: 'break'},
            {name: 'id_h_days'}
          ]
        }
      }
    },
    props: ['id_type'],
    computed: {
      jbParentData () {
        return {
          id_shifts_type: this.id_type
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Shift/ShiftMaster.vue